<template>
  <div>
    <Layout class="app-frame" :siderCollapsed="siderCollapsed" :siderFixed="layoutConfig.siderFixed">
      <Sider :theme="layoutConfig.siderTheme">
        <Menu :theme="layoutConfig.siderTheme"></Menu>
      </Sider>
      <Layout :headerFixed="layoutConfig.headerFixed">
        <HHeader theme="white">
          <Head @openSetting="openSetting = true"></Head>
        </HHeader >
        <SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
        <Content>
          <div class="app-frame-content" style="margin-top: 50px; display: flex">
            <div v-width="400" style="margin: 0 auto">
              <Form ref="form" :labelWidth="120" :label-width="150" :rules="rules" :model="data">
                <FormItem label="旧密码" prop="oldPassword">
                  <input :type="typeInfo" v-model="data.oldPassword" @focus="switchType" />
                </FormItem>
                <FormItem label="新密码" prop="newPassword">
                  <input :type="typeInfo" v-model="data.newPassword" @focus="switchType" />
                </FormItem>
                <FormItem label="再次输入新密码" prop="newPassword1">
                  <input :type="typeInfo" v-model="data.newPassword1" @focus="switchType" />
                </FormItem>
                <FormItem>
                  <Button color="primary" :loading="isLoading" @click="submit">提交</Button>&nbsp;&nbsp;&nbsp;<Button @click="reset">重置</Button>
                </FormItem>
              </Form>
            </div>
          </div>
          <HFooter>
            <Footer></Footer>
          </HFooter>
        </Content>
      </Layout>
    </Layout>
    <Modal v-model="openSetting" type="drawer-right">
      <appLayoutSetting :layoutConfig="layoutConfig"></appLayoutSetting>
    </Modal>
  </div>
</template>
<script>
import Head from './common/include/_header'
import Menu from './common/include/_left'
import Footer from './common/include/_footer'
import SysTabs from '../dxrj.sdk/common/sys-tabs'
import { mapState } from 'vuex'
import appLayoutSetting from './common/include/modules/app-layout-setting'
export default {
  data () {
    return {
      isLoading: false,
      data: {
        userId: window.localStorage.getItem('PSOP_USERID'),
        oldPassword: '',
        newPassword: '',
        newPassword1: ''
      },
      rules: {
        required: ['oldPassword', 'newPassword', 'newPassword1'],
        combineRules: [
          {
            refs: ['newPassword', 'newPassword1'],
            valid: {
              valid: 'equal',
              message: '两次输入的密码不一致'
            }
          }
        ]
      },
      typeInfo: 'text',
      openSetting: false,
      layoutConfig: {
        siderTheme: 'dark',
        showSystab: true,
        headerFixed: true,
        siderFixed: true
      }
    }
  },
  computed: {
    ...mapState(['siderCollapsed'])
  },
  components: {
    Head,
    Menu,
    SysTabs,
    Footer,
    appLayoutSetting
  },
  mounted() {
    this.reset()
  },
  methods: {
    switchType() {
      this.typeInfo = 'password'
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        httpKit.post($api_eap.user.password, this.data).then(res => {
          if (res.status == '200') {
            this.isLoading = false;
            this.$alert('密码修改成功，请重新登录', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
                this.$router.push({ path: '/#' })
              }
            })
          } else {
            this.$message.error(`未通过验证。`)
          }
        })
        // this.$Message('验证成功')
        // this.isLoading = true

        // setTimeout(() => {
        //   this.isLoading = false
        // }, 1000)
      } else {
        this.$Message.error(`还有${validResult.messages.length}个错误未通过验证。`)
      }
    },
    reset() {
      this.data.oldPassword = '';
      this.data.newPassword = '';
      this.data.newPassword1 = '';
    }
  }
}
</script>
<style lang='less'>

</style>
